import React from 'react';
import {makeStyles} from 'tss-react/mui';
import ErrorIcon from '@mui/icons-material/Error';
import ItemIcon from '@mui/icons-material/ReportGmailerrorred';
import Tooltip, {tooltipClasses} from '@mui/material/Tooltip';
import InputAdornment from '@mui/material/InputAdornment';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

const useStyles = makeStyles()((theme) => ({
   //estilo del tooltip para q sea mas visible
   tooltip: {
      [`& .${tooltipClasses.tooltip}`]: {
         backgroundColor: '#f5f5f9',
         color: 'red',
         fontSize: theme.typography.pxToRem(12),
         border: `1px solid ${theme.palette.error.main}`,
         paddingRight: 4,
         paddingLeft: 0,
         paddingTop: 0,
         paddingBottom: 0
      }
   },
   //estilo de la flecha de tooltip para no chocar con la modificacion del estilo `tooltip`
   tooltipArrow: {
      color: theme.palette.error.main
   }
}));

export interface CEC_ErrorVistaProps {
   errores: string[];
}
function ErrorList({errores}: CEC_ErrorVistaProps) {
   return (
      <List dense disablePadding>
         {errores.map((currErr, inx) => (
            <ListItem key={inx} disablePadding>
               <ListItemIcon style={{minWidth: 0}}>
                  <ItemIcon fontSize="small" color="error" />
               </ListItemIcon>
               <ListItemText primary={currErr} />
            </ListItem>
         ))}
      </List>
   );
}
export function CEC_ErrorIcon({errores}: CEC_ErrorVistaProps) {
   const classes = useStyles();
   return (
      <Tooltip
         placement="bottom-start"
         title={<ErrorList errores={errores} />}
         classes={{popper: classes.classes.tooltip, arrow: classes.classes.tooltipArrow}}
         arrow
         slotProps={{
            popper: {
               modifiers: [
                  {
                     name: 'offset',
                     options: {
                        offset: [0, -8]
                     }
                  }
               ]
            }
         }}
      >
         <ErrorIcon color="error" />
      </Tooltip>
   );
}

export function CEC_ErrorInputAdornment({errores}: CEC_ErrorVistaProps) {
   return (
      <InputAdornment position="end">
         <CEC_ErrorIcon errores={errores} />
      </InputAdornment>
   );
}
